import { cn } from '../../lib/cn'

type EyebrowTone = 'brass' | 'gilt' | 'fairway'

interface EyebrowProps {
  children: React.ReactNode
  /** `gilt` for pine/dark grounds; `fairway` when brass sits too close to a CTA. */
  tone?: EyebrowTone
  className?: string
}

/**
 * The letterspaced small-caps label that opens most sections.
 *
 * ACCESSIBILITY — this is why `brass` maps to `--color-brass-deep`, not
 * `--color-brass`: at 12px/600 this is *normal-size* text under WCAG, so it
 * needs 4.5:1. The design cards' brass (#9C7C43) on paper is 3.38:1 and fails.
 * brass-deep (#856637) is 4.6:1 and reads as the same metal. Plain brass stays
 * correct for the rules and crests it was picked for — those are non-text.
 */
const toneStyles: Record<EyebrowTone, string> = {
  brass: 'text-brass-deep',
  gilt: 'text-gilt',
  fairway: 'text-fairway',
}

export function Eyebrow({ children, tone = 'brass', className }: EyebrowProps) {
  return (
    <span
      className={cn(
        'block text-xs font-semibold uppercase tracking-[0.24em]',
        toneStyles[tone],
        className,
      )}
    >
      {children}
    </span>
  )
}
